import {clone, isNil} from 'ramda';

import {PurchasePriceRuleModifiers, PurchasePriceRuleResponseBody} from '@dms/api/sales';

export type NewPurchasePriceRuleMode = 'COPY_DEFAULT' | 'COPY_OTHER' | 'WITHOUT_MODIFIERS';

interface BuildPurchasePriceRuleTemplateParams {
  mode: NewPurchasePriceRuleMode;
  rules: PurchasePriceRuleResponseBody[];
  /** Rule to copy from; used only with the `COPY_OTHER` mode. */
  sourceRuleId: string | null;
}

const disableModifiers = (modifiers: PurchasePriceRuleModifiers) => ({
  electricVehicle: {...modifiers.electricVehicle, enabled: false},
  highMileage: {...modifiers.highMileage, enabled: false},
  higherAge: {...modifiers.higherAge, enabled: false},
});

/**
 * Builds the values a new rule starts from. Returns `null` when the source rule does not exist.
 * Name, scope and position are deliberately not part of the template.
 */
export const buildPurchasePriceRuleTemplate = (params: BuildPurchasePriceRuleTemplateParams) => {
  const source =
    params.mode === 'COPY_OTHER'
      ? params.rules.find((rule) => !rule.system && rule.id === params.sourceRuleId)
      : params.rules.find((rule) => rule.system);

  if (isNil(source)) {
    return null;
  }

  return {
    priceBands: clone(source.priceBands),
    warrantyCost: source.warrantyCost,
    modifiers:
      params.mode === 'WITHOUT_MODIFIERS'
        ? disableModifiers(source.modifiers)
        : clone(source.modifiers),
  };
};
